import type { ProjectPolicyConflictsPageEntryPoint } from './ProjectPolicyConflictsPage.entrypoint.types.tsx';
import { createProjectPolicyConflictsPageResolverEntryPoint } from './createProjectPolicyConflictsPageResolverEntryPoint.entrypoint.tsx';

export const corePolicyConflictsPageEntryPoint: ProjectPolicyConflictsPageEntryPoint =
	createProjectPolicyConflictsPageResolverEntryPoint('core');
